import {
  icon1,
  icon2,
  icon3,
  backend,
  creator,
  web,
  technoforte_company,
  todo_project,
  startup_project,
} from "../assets";
import {
  Python,
  FastAPI,
  PostgreSQL,
  MongoDB,
  Redis,
  MySQL,
  NextJs,
  TypeScript,
  React,
  Docker,
  AWS,
  EC2,
  Terraform,
  GitHubDark,
  Linux,
  TailwindCSS,
  Redux,
  I18next,
  Zod,
  Swagger,
  C,
  CPlusPlus,
  Java,
} from "developer-icons";

const TOOL_ICON_URLS = {
  rancher:
    "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/rancher/rancher-original.svg",
};

const skillTree = [
  {
    id: "languages",
    label: "Languages",
    skills: [
      { name: "TypeScript", icon: TypeScript },
      { name: "Python", icon: Python },
      { name: "C", icon: C },
      { name: "C++", icon: CPlusPlus },
      { name: "Java", icon: Java },
      { name: "SQL" },
    ],
  },
  {
    id: "frontend",
    label: "Frontend",
    skills: [
      { name: "Next.js", icon: NextJs },
      { name: "React", icon: React },
      { name: "Tailwind CSS", icon: TailwindCSS },
      { name: "Redux Toolkit", icon: Redux },
      { name: "next-intl", icon: I18next },
      { name: "Zod", icon: Zod },
    ],
  },
  {
    id: "backend",
    label: "Backend",
    skills: [
      { name: "FastAPI", icon: FastAPI },
      { name: "SQLAlchemy" },
      { name: "Pydantic" },
      { name: "Odoo" },
      { name: "AsyncIO" },
      { name: "REST APIs", icon: Swagger },
    ],
  },
  {
    id: "databases",
    label: "Databases",
    skills: [
      { name: "PostgreSQL", icon: PostgreSQL },
      { name: "MongoDB", icon: MongoDB },
      { name: "Redis", icon: Redis },
      { name: "MySQL", icon: MySQL },
      { name: "TablePlus" },
    ],
  },
  {
    id: "devops",
    label: "DevOps & Cloud",
    skills: [
      { name: "Docker", icon: Docker },
      { name: "Rancher", image: TOOL_ICON_URLS.rancher },
      { name: "AWS", icon: AWS },
      { name: "EC2", icon: EC2 },
      { name: "RDS" },
      { name: "S3" },
      { name: "Terraform", icon: Terraform },
      { name: "GitHub Actions", icon: GitHubDark },
      { name: "Linux", icon: Linux },
      { name: "MinIO" },
    ],
  },
];

const navLinks = [
  { id: "home", title: "Home" },
  { id: "about", title: "About" },
  { id: "work", title: "Work" },
  { id: "education", title: "Education" },
  { id: "project", title: "Projects" },
  { id: "contact", title: "Contact" },
];

const services = [

  {
    title: "Frontend Developer",
    icon: web,
  },  {
    title: "Backend Developer",
    icon: backend,
  },
  {
    title: "Identity & Access Management",
    icon: creator,
  },
];

const experiences = [
  {
    title: "Associate Software Engineer",
    company_name: "Technoforte Software Pvt. Ltd.",
    icon: technoforte_company,
    date: "Oct 2025 – Present · Bengaluru, IN · Full-time · On-site",
    points: [
      "Built a dynamic registry framework — JSON-based configurable library for intake workflows, change-request approval flows, and form configuration, reused across multiple country deployments",
      "Delivered API-backed localization and theming — configurable multi-language and multi-theme support across registry deployments",
      "Optimised Docker builds and GitHub Actions CI/CD pipelines for faster, reliable registry deployments",
      "Delivered program management features for national welfare registries",
    ],
  },
  {
    title: "Junior Software Engineer",
    company_name: "Technoforte Software Pvt. Ltd.",
    icon: technoforte_company,
    date: "Jun 2024 – Sep 2025 · Bengaluru, IN · Full-time · On-site",
    intro:
      "Working on an open-source DPI platform for national welfare registries and beneficiary management.",
    points: [
      "Built Odoo modules for registry and program management workflows",
      "Developed document management and upload pipelines for registry and beneficiary data using MinIO",
      "Onboarded onto FastAPI backend services and PostgreSQL data layers",
      "Supported multiple registry implementations across country deployments",
    ],
  },
];

const education = [
  {
    degree: "Bachelor of Technology — Computer Science & Engineering",
    school: "Biju Patnaik University of Technology (BPUT), Rourkela",
    location: "Odisha, India",
    date: "Jul 2020 – Jul 2024",
    grade: "CGPA: 8.32 / 10",
    badge: "BT",
    highlights: [
     ""
    ],
  },
  {
    degree: "Higher Secondary (12th) — Science",
    school: "M.K College , Madhuban , Sitamarhi",
    location: "Bihar, India",
    date: "2017 – 2019",
    grade: "Percentage: 81.2%",
    badge: "12",
    highlights: [
      "",
    ],
  },
  {
    degree: "Secondary (10th)",
    school: "Higher Secondary School, Haribela, Sitamarhi",
    location: "Bihar, India",
    date: "2016-2016",
    grade: "Percentage: 77.4%",
    badge: "10",
    highlights: [
      "",
    ],
  },
];

const projects = [
  {
    name: "AuthEngine — Admin Dashboard",
    description: `Companion Next.js admin dashboard for the AuthEngine IAM platform — 20+ screens for tenant and user management, MFA enrollment, WebAuthn passkey administration, and service configuration. Consumes AuthEngine REST APIs with a production deployment at app.authengine.org.`,
    tags: [
      { name: "Next.js", color: "blue-text-gradient" },
      { name: "TypeScript", color: "green-text-gradient" },
      { name: "React", color: "purple-text-gradient" },
      { name: "IAM", color: "orange-text-gradient" },
    ],
    image: startup_project,
    source_link: "https://github.com/auth-engine/auth-engine-dashboard",
    website_link: "https://app.authengine.org",
    website_label: "Live App",
  },
  {
    name: "AuthEngine — API",
    description: `Open-source IAM platform backend with 90+ REST endpoints, multi-tenant RBAC, and a live public deployment on AWS. Implements OAuth2/OIDC provider flows, six authentication strategies (email/password, OAuth, magic link, TOTP MFA, WebAuthn), and Redis-backed token introspection. Hybrid data layer across PostgreSQL, Redis, and MongoDB audit logs.`,
    tags: [
      { name: "FastAPI", color: "blue-text-gradient" },
      { name: "PostgreSQL", color: "green-text-gradient" },
      { name: "OAuth2", color: "orange-text-gradient" },
      { name: "OIDC", color: "pink-text-gradient" },
      { name: "AWS", color: "purple-text-gradient" },
    ],
    image: todo_project,
    source_link: "https://github.com/auth-engine",
    website_link: "https://api.authengine.org/docs",
    website_label: "API Docs",
  },
];

const footerIcons = [
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/q-niranjan/",
    icon: icon1,
  },
  {
    name: "GitHub",
    link: "https://github.com/Q-Niranjan",
    icon: icon2,
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/nethore_niranjan",
    icon: icon3,
  },
];

const toRotateText = [
  "Backend Developer at Technoforte",
  "Open Source Contributor at OpenG2P",
  "Creator of AuthEngine platform",
];

export {
  navLinks,
  services,
  skillTree,
  experiences,
  education,
  projects,
  toRotateText,
  footerIcons,
};
